import { IETFTrackerResponse } from "@dl/declarations";
import axios from "axios";
import { baseURL } from "./api";

export const getDefiLlamaETFs = async () => {
    const res = await axios.get<{ data: { bitcoin: IETFTrackerResponse[]; ethereum: IETFTrackerResponse[] } }>(`${baseURL}/website/system/defillama/etfs`)

    return res.data
}